<script setup>
import { ref } from 'vue'
import { v4 as uuidv4 } from 'uuid'

// model
const model = defineModel()

// props
const props = defineProps({
  id: {
    type: String,
    default: () => uuidv4()
  },
  value: {
    type: [String,Boolean],
    default: '',
  },
  name: {
    type: String,
    default: ''
  },
  classNm : {
    type: String,
    default: 'form-check-input'
  },
  disabled:{
    type: Boolean,
    default: false
  }
})

// emit
const emit = defineEmits(['radioChange'])

</script>

<template>
  <input :class="classNm" v-model="model" type="radio" :value="value" :name="name" :id="id"  @change="emit('radioChange', $event)" :disabled="disabled">
</template>